import { FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, RadioGroup, Radio } from '@mui/material'
import { useTranslation } from 'react-i18next'

function NotificationGroup({ lessonState, handleNotificationsChange }: any) {
  const { t } = useTranslation(['global'])

  return (
    <>
      <FormControl component="fieldset">
        <FormLabel component="legend">{t('notifications')}</FormLabel>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox checked={Boolean(lessonState.notifications.email)} onChange={handleNotificationsChange('email')} name="email" />
            }
            label={t('email')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(lessonState.notifications.notification)}
                onChange={handleNotificationsChange('notification')}
                name="notification"
              />
            }
            label={t('notification')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(lessonState.notifications.integration)}
                onChange={handleNotificationsChange('integration')}
                name="integration"
              />
            }
            label={t('integration')}
          />
        </FormGroup>
      </FormControl>

      <FormControl component="fieldset">
        <FormLabel component="legend">Notificar a:</FormLabel>
        <RadioGroup
          aria-label="notifyTo"
          name="notifyTo"
          value={lessonState.notifications.hierarchy}
          onChange={handleNotificationsChange('hierarchy')}
        >
          <FormControlLabel value="0" control={<Radio />} label={t('all')} />
          <FormControlLabel value="1" control={<Radio />} label={t('commercial')} />
        </RadioGroup>
      </FormControl>
    </>
  )
}

export default NotificationGroup
